import jwtDecode from "jwt-decode";
import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  Grid,
  Typography,
  useTheme,
} from "@mui/material";
import { styles } from "../../styles/styles";

import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField"; // Import FilePond image preview styles

import { useFormik } from "formik";
import * as Yup from "yup";

import {
  activateUser,
  getCodeFromFb,
  getUserByUserRef,
  updateCodeLink,
} from "../../store/actions/users";

import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { refreshToken } from "../../store/actions/auth";
import { ASbutton } from "../buttons/ASbutton";

const MySwal = withReactContent(Swal);

export const GenerateSummary = ({
  apportionmentPrice,
  setApportionmentPrice,
  data,
  selectedPlan,
  userisActive,
  userHasCode,
}) => {
  const theme = useTheme();
  const { idToken } = useSelector((state) => state.auth);
  const [priceNoIVA, setPriceNoIva] = useState(0);
  const [priceToCharge, setPriceToCharge] = useState(0);
  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Campo requerido"),
  });
  const [loading, setloading] = useState(true);

  useEffect(() => {
    const overallDate = new Date();
    const year = overallDate.getFullYear();
    const month = overallDate.getMonth() + 1;
    const date = overallDate.getDate();

    //Days in the month
    const apportionmentDays = new Date(year, month, 0).getDate();
    //Days left in the month
    const apportionment = apportionmentDays - date + 1;
    //SET Price without IVA
    setPriceNoIva(selectedPlan.finalPrice - selectedPlan.finalPrice * 0.13);

    setApportionmentPrice((priceNoIVA / apportionmentDays) * apportionment);

    setPriceToCharge(
      (apportionmentPrice + apportionmentPrice * 0.13).toFixed(2)
    );
  }, [apportionmentPrice, selectedPlan, priceNoIVA]);

  const renderList = () => {
    if (!selectedPlan.data) {
      // Data is not available, show loading indicator
      return (
        <Grid container item md={12}>
          <CircularProgress />
        </Grid>
      );
    }

    return selectedPlan.data.map((data, index) => (
      <Grid container item md={12} key={index}>
        <Grid item md={8}>
          <Typography
            textAlign={"left"}
            variant="body1"
            sx={{ fontSize: "0.8rem !important" }}
          >
            {data?.description}
          </Typography>
        </Grid>
        <Grid item md={4}>
          <Typography variant="body2" key={data.id} textAlign={"right"}>
            {data?.value}
          </Typography>
        </Grid>
      </Grid>
    ));
  };

  const formik = useFormik({
    initialValues: {
      email: data?.email,
      price: selectedPlan.price ?? "0",
      acceptTerms: false,
      billNumber: 0,
      apportionmentPrice: 0,
    },
    enableReinitialize: true,
  });

  const isValidToken = (token) => {
    if (!token) {
      return false; // If token is missing or undefined, it is not valid
    }

    const decodedToken = jwtDecode(token);
    const currentTime = Math.floor(Date.now() / 1000);

    return currentTime < decodedToken.exp;
  };

  //   if (loading) {
  //     return (
  //       <Box sx={styles.formContainer}>
  //         <Box sx={[styles.plansCard, { mt: 0, mb: 2 }]}>
  //           <CircularProgress />
  //         </Box>
  //       </Box>
  //     );
  //   }
  if (!selectedPlan) {
    return (
      <Box>
        <Box sx={styles.formTitle} mb={2}>
          <Typography
            variant="h7"
            sx={{ fontWeight: "bold", color: theme.palette.primary.main }}
          >
            Detalles
          </Typography>
        </Box>
        <Grid container columnGap={2} justifyContent={"flex-start"}>
          <Grid item md={12} container mb={3} sx={styles.summaryCard2}>
            {(userisActive || userHasCode) && (
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  background: "rgba(0, 0, 0, 0.7)",
                  width: "100%",
                  height: "100%",
                  zIndex: 999,
                  borderRadius: "18px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: 19.5,
                  }}
                >
                  <Typography
                    variant="h7"
                    sx={{
                      fontWeight: "bold",
                      color: "white",
                      textAlign: "center",
                      margin: "1em auto",
                      pr: 0.8,
                      pl: 0.8,
                    }}
                  >
                    {userHasCode
                      ? "Usuario ya tiene código activo"
                      : "Usuario ya se encuentra activo, contacte a soporte"}
                  </Typography>
                </Box>
              </div>
            )}
            <Box sx={[styles.plansCard, { mt: 0, mb: 2 }]}>--</Box>
          </Grid>
        </Grid>

        {/* @ND ROW */}
      </Box>
    );
  }

  return (
    <Box>
      <Box sx={styles.formTitle} mb={2}>
        <Typography
          variant="h7"
          sx={{ fontWeight: "bold", color: theme.palette.primary.main }}
        >
          Detalles
        </Typography>
      </Box>
      <Grid container columnGap={2} justifyContent={"flex-start"}>
        <Grid item md={12} container mb={3} sx={styles.summaryCard2}>
          {(userisActive || userHasCode) && (
            <div
              style={{
                position: "absolute",
                top: 0,
                right: 0,
                background: "rgba(0, 0, 0, 0.7)",
                width: "100%",
                height: "100%",
                zIndex: 999,
                borderRadius: "18px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: 18,
                }}
              >
                <Typography
                  variant="h7"
                  sx={{
                    fontWeight: "bold",
                    color: "white",
                    textAlign: "center",
                    margin: "1em auto",
                    pr: 0.8,
                    pl: 0.8,
                  }}
                >
                  {userHasCode
                    ? "Usuario ya tiene código activo"
                    : "Usuario ya se encuentra activo, contacte a soporte"}
                </Typography>
              </Box>
            </div>
          )}
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",

              flexDirection: "column",
            }}
          >
            <Typography variant="h6">{selectedPlan?.subTier}</Typography>

            <Grid
              container
              sx={{
                margin: "0 auto",
                mt: 2,

                pt: 1,
                pb: 1,
              }}
            >
              <Box mb={1}>
                <Typography variant="body1">Detalles del Plan</Typography>
              </Box>
              {renderList()}
            </Grid>
          </Box>
        </Grid>
      </Grid>

      {/* @ND ROW */}
    </Box>
  );
};
